import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AddressLookupType } from '../../../config/address-lookup.config';
import { Address, AddressLookupResponse, AddressLookupStatus } from '../../../domain/address';
import { DataLoadState, ErrorType, initialDataLoadState } from '../../../store/reducers/common';

type LookupRequest = {
  address: Address;
  type: AddressLookupType;
};

type AddressLookupState = {
  enteredAddress?: Address;
  suggestedAddress?: Address;
  lookupStatus?: AddressLookupStatus;
  type: AddressLookupType;
} & DataLoadState;

const initialState: AddressLookupState = {
  ...initialDataLoadState,
  type: 'none',
};

const slice = createSlice({
  name: 'checkAddress',
  initialState,
  reducers: {
    lookupAddress: (state, { payload: { address, type } }: PayloadAction<LookupRequest>) => ({
      ...state,
      enteredAddress: address,
      suggestedAddress: undefined,
      lookupStatus: undefined,
      loading: true,
      error: null,
      type,
    }),
    lookupAddressSuccess: (state, action: PayloadAction<AddressLookupResponse>) => ({
      ...state,
      lookupStatus: action.payload.status,
      suggestedAddress: action.payload.address,
      loading: false,
      error: null,
    }),
    lookupAddressFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
    resetAddressLookup: () => initialState,
    addressResolved: (state) => state,
    setAddressLookupType: (state, { payload }: PayloadAction<AddressLookupType>) => ({
      ...state,
      type: payload,
    }),
    setEnteredAddress: (state, { payload }: PayloadAction<Address>) => ({
      ...state,
      enteredAddress: payload,
      suggestedAddress: undefined,
      lookupStatus: undefined,
      error: null,
    }),
  },
});

export const addressLookupReducer = slice.reducer;
export const {
  lookupAddress,
  lookupAddressFail,
  lookupAddressSuccess,
  resetAddressLookup,
  addressResolved,
  setAddressLookupType,
  setEnteredAddress,
} = slice.actions;
